import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';

import LandingPage from '../src/LandingPage/LandingPage';

import Dashboard from './Views/User/Dashboard/Dashboard';

import Reels from './Views/User/Reels/Reels';

import Cart from './Views/User/Cart/cart';

import Profilescreen from './Views/User/profilepage/Profilescreen';

import Profilesettings from './Views/User/profilepage/Profilesettings';

import Inbox from './Views/User/Inbox/Inbox';

import Payment from './Views/User/Payment/Payment';

import PaymentSuccess from './Views/User/Payment/PaymentSuccess';

import PaymentFail from './Views/User/Payment/PaymentFail';

import GoogleMap from './Views/User/Tracking/GoogleMap';

import RestaurantPage from './Views/User/Reasaurant page/RestaurantPage';

import FoodDescription from './Views/User/Reasaurant page/FoodDescription';

import Editprofile from './Views/User/profilepage/Editprofile';

import ChangePassword from './Views/User/profilepage/ChangePassword';

import Changelanguage from './Views/User/profilepage/changelanguage';

import UpdateAddresses from './Views/User/profilepage/UpdateAddresses';

import Switchaccount from './Views/User/profilepage/Switchaccount';

import Tabs from './Views/User/Search/Tabs';

import Foods from './Views/User/Search/Food';

import Restaurants from './Views/User/Search/Restaurant';

import Post from './Views/User/Search/Post';

import Users from './Views/User/Search/Users';

import Offer from './Views/User/Search/Offer';

import PageNotFound from './Views/User/PageNotFound/PageNotFound';

import Signup from './auth/Signup/Signup';
import Login from './auth/Login/Login';
import VerifyOTP from './auth/VerifyOTP/VerifyOTP';
import ForgetPassword from './auth/ForgetPassword/ForgetPassword';
import ResetPassword from './auth/ResetPassword/ResetPassword';

import ViewMenu from './Views/User/ViewMenu/ViewMenu';
import OrderDetails from './Views/User/Inbox/OrderDetails';
import PrivacyPolicy from './Views/User/profilepage/PrivacyPolicy';
import TermsAndCondition from './Views/User/profilepage/TermsAndCondition';
import DineAndVibe from './Views/User/Events/DineAndVibe';
import EventDetailsInApp from './Views/User/Events/EventDetailsInApp';
import MyTicketsInApp from './Views/User/Tickets/MyTicketsInApp';


function Userrouter() {
    const [tabName, setTabName] = useState('restaurant');
    const [searchQuery, setSearchQuery] = useState('');
    const [isReset, setReset] = useState(null);

    return (
        <div>
            <BrowserRouter>
              
                <Routes>
                    <Route path="/" element={<LandingPage></LandingPage>}></Route>
                    <Route path='/signup' element={<Signup></Signup>}></Route>
                    <Route path='/login' element={<Login/>}></Route>
                    <Route path='/verify-otp' element={<VerifyOTP setReset={setReset} isReset={isReset}/>}></Route>
                    <Route path='/forget-password' element={<ForgetPassword setReset={setReset} isReset={isReset}/>}></Route>
                    <Route path='/reset-password' element={<ResetPassword/>}></Route>
                    <Route path="/dashboard" element={<Dashboard />}></Route>
                    <Route path="/reels" element={<Reels />}></Route>
                    <Route 
                        path="/reels/:reelsId" 
                        element={<Reels />}>
                    </Route>
                    <Route path='/restaurant/:id' element={<ViewMenu />}></Route>
                    <Route
                        path="/orders"
                        element={ 
                            <Inbox></Inbox>
                        }
                    ></Route>
                    <Route
                        path="/orders/:id"
                        element={ 
                            <OrderDetails />
                        }
                    ></Route>

                    <Route path="/Cart" element={<Cart></Cart>}></Route>
                    <Route path="/Payment" element={<Payment></Payment>}></Route>
                    <Route
                        path="/PaymentSuccess"
                        element={<PaymentSuccess></PaymentSuccess>}
                    ></Route>
                    <Route
                        path="/PaymentFail"
                        element={<PaymentFail></PaymentFail>}
                    ></Route>
                    <Route path="/GoogleMap" element={<GoogleMap></GoogleMap>}></Route>

                    <Route
                        path="/RestaurantPage"
                        element={<RestaurantPage></RestaurantPage>}
                    ></Route>
                    <Route
                        path="/FoodDescription"
                        element={<FoodDescription></FoodDescription>}
                    ></Route>

                    <Route
                        path="/profile"
                        element={<Profilescreen></Profilescreen>}
                    ></Route>
                    <Route
                        path="/profile/:userName"
                        element={<Profilescreen></Profilescreen>}
                    ></Route>
                    <Route
                        path="/profilesettings"
                        element={<Profilesettings></Profilesettings>}
                    ></Route>

                    <Route path="/edit-profile" element={<Editprofile />} />
                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
                    <Route path="/change-language" element={<Changelanguage />} />
                    <Route path="/update-addresses" element={<UpdateAddresses />} />
                    <Route path="/switch-account" element={<Switchaccount />} />

                    <Route
                        path="/search"
                        element={
                            <Tabs
                                tabName={tabName}
                                setTabName={setTabName}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                            />
                        }
                    />
                    <Route path="/foods" element={<Foods />} />
                    <Route path="/restaurants" element={<Restaurants />} />
                    <Route path="/post" element={<Post />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/offer" element={<Offer />} />
                    {/* In-app layout for Events (like Reels) */}
                    <Route path="/events" element={<DineAndVibe />} />
                    <Route path="/events/:id" element={<EventDetailsInApp />} />
                    {/* My Tickets */}
                    <Route path="/my-tickets" element={<MyTicketsInApp />} />
                    {/* Backward compatibility + alias */}
                    <Route path="/dine-vibe" element={<Navigate to="/events" replace />} />
                    <Route path="/dine-vibe/events/:id" element={<Navigate to="/events/:id" replace />} />
                    <Route path="/event/:id" element={<EventDetailsInApp />} />

                    <Route path="*" element={<PageNotFound />} />
                </Routes>
               
            </BrowserRouter>
        </div>
    );
}

export default Userrouter;

